import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MapPin, Edit, Trash2, Map as MapIcon } from 'lucide-react';

/**
 * Card component for displaying an area with its stats
 */
export default function AreaCard({ area, locationCount, locationsWithGPS, onEdit, onDelete, hasLocations }) {
  return (
    <Card className="group relative overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-0">
      {/* Gradient top border */}
      <div className="h-1.5 bg-gradient-to-r from-blue-500 to-indigo-500"></div>
      
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
              <MapIcon className="w-7 h-7 text-white" />
            </div>
            <div>
              <span className="text-xl font-bold text-slate-900">{area.name}</span>
              <div className="text-sm text-slate-500 font-normal flex items-center space-x-1">
                <MapPin className="w-3 h-3" />
                <span>{area.region}</span>
              </div>
            </div>
          </div>
        </CardTitle>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-4">
          {/* Stats */}
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-lg p-3 text-center border border-slate-200">
              <div className="text-2xl font-bold text-slate-900">{locationCount}</div>
              <div className="text-xs text-slate-600">Lokaliteter</div>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-teal-50 rounded-lg p-3 text-center border border-slate-200">
              <div className="text-2xl font-bold text-slate-900">{locationsWithGPS}</div>
              <div className="text-xs text-slate-600">Med GPS</div>
            </div>
          </div>
          
          {/* Action buttons */}
          <div className="flex space-x-2 pt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEdit(area)}
              className="flex-1 h-10 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 transition-all"
            >
              <Edit className="w-4 h-4 mr-1" />
              Rediger
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(area.id)}
              className="h-10 w-10 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
              disabled={hasLocations}
              title={hasLocations ? 'Kan ikke slettes - har lokaliteter' : 'Slett område'}
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
